import { z } from 'zod';

export const PlaceOfWorkSchema = z.object({
  name: z.string(),
});
export type PlaceOfWorkDTO = z.infer<typeof PlaceOfWorkSchema>;